import Icon from '../../components/Icon.vue'

Icon.register({"brands/microsoft":{"width":448,"height":512,"paths":[{"d":"M0 32H214.6V246.6H0V32zM233.4 32H448V246.6H233.4V32zM0 265.4H214.6V480H0V265.4zM233.4 265.4H448V480H233.4V265.4z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/microsoft.js
// module id = null
// module chunks = 